define(function(require) {
	// general
	const Backbone = require('backbone');
	const Radio = require('backbone.radio');
	const AddAttachmentChannel = Radio.channel('addAttachmentChannel');
	const ViewManager = require('civicsUtils/view_manager');
	const Utils = require('civicsUtils/general_utilities');
	const AvailableFeatures = require('civicsUtils/available_features');

	const ModalTemplate = require('civicsViews/attachments/templates/t_itv_attachment_viewer.hbs');

	const AttachmentModel = require('civicsModels/attachment_model');
	const AttributesTable = require('./v_cpv_attributes');
	const constants = require('civicsUtils/constants');

	return Marionette.LayoutView.extend({
		regions: {
			attribRegion: '.attribute-container'
		},
		ui: {
			description: '.description .input-textarea',
			cancelButton: '.btn-cancel',
			submitButton: '.btn-save',
			closeButton: '.bbm-btn-close',
			previousButton: '.go-previous',
			nextButton: '.go-next',
			modalContainer: '.attachment-modal-content',
			attributeTable: '.attribute-container',
			dataForm: '.attachment-data-form',
			$documentType: '.document-type',
			$imagePreview: '.image-thumbnail',
			$nonImagePreview: '.file-icon-preview',
			$failed: '.rule-failed'

		},
		className: 'edit-attach',
		events: {
			'click @ui.cancelButton': 'closeClicked',
			'click @ui.closeButton': 'closeClicked',
			'click @ui.previousButton': 'previousClicked',
			'click @ui.nextButton': 'nextClicked',
			'click @ui.submitButton': 'submitClicked',
			'droppyChange @ui.$documentType': 'onDocumentTypeChanged',
		},

		initialize: function(options) {
			var self = this;
			this.config = options.config ? options.config : {};
			this.model = options.model;
			this.attachment_index = options.attachment_index;
			this.parentMoniker = options.parentMoniker;
			this.parentPrimaryKey = options.parentPrimaryKey;
			this.isAddProcess = options.isAddProcess;
			this.documentType = options.documentType;

			this.isCustomer = options.isCustomer;
			this.isServiceProvider = options.isServiceProvider;
			this.isPublic = options.isPublic;
			this.canUpdate = options.canUpdate;

			this.newAttachmentsCollection = options.newAttachmentsCollection;
			this.file = options.file;

			this.documentTypeCollection = this.loadDocumentTypes(options.documentTypeCollection, self.isAddProcess);

			this.parentCollection = new Backbone.Collection(this.model.collection.filter(function(mod) {
				if (self.isAddProcess) {
					return true;
				}

				var docType = (typeof mod.get('documentType').get('portalConfigurations') !== 'undefined') ? mod.get('documentType') : self.determineDocumentType(mod.get('documentType'));
				var acts = self.getActionPermissions(docType);
				var canOpen = (self.isCustomer && acts.open.customer) || (self.isServiceProvider && acts.open.serviceProvider) || (self.isPublic && acts.open.public);
				var canUpdate = (self.isCustomer && acts.update.customer) || (self.isServiceProvider && acts.update.serviceProvider) || (self.isPublic && acts.update.public);

				let virusScanResults = mod.get('virusScanResults')?.toJSON() || {safe:true}

				return virusScanResults.safe && (canOpen || canUpdate);
			}));

		},
		loadDocumentTypes: function(documentTypeCollection, isAddProcess) {
			var self = this;

			var filteredDocumentTypeCollection = [];
			var filteredCollection = documentTypeCollection.filter(function(documentType) {
				var description = documentType.get('description').length > 0 ? documentType.get('description') : documentType.get('name')
				documentType.set('portalDescription', documentType.get('portalDescription').length > 0 ? documentType.get('portalDescription') : description);

				if (!self.isAddProcess) {
					return true;
				} else {
					var includeDocType = false;
					documentType.get('portalConfigurations').each(function(portalConfig) {
						if (self.isCustomer && !self.isProvider) {
							if (portalConfig.get('action') == 'Add' && portalConfig.get('customer')) {
								includeDocType = true;
							}
						} else if (self.isProvider && !self.isCustomer) {
							if (portalConfig.get('action') == 'Add' && portalConfig.get('serviceProvider')) {
								includeDocType = true;
							}
						} else {
							if (portalConfig.get('action') == 'Add' && portalConfig.get('public')) {
								includeDocType = true;
							}
						}
					});
					return includeDocType;
				}
			});

			var collection = new Backbone.Collection(filteredCollection);
			collection.comparator = function(object) {
				return object.get('portalDescription');
			}
			collection.sort();
			return collection;

		},
		getActionPermissions: function(doctype) {
			var actions = {};
			if (doctype != null) {
				doctype.get('portalConfigurations').forEach(function(actionConfig) {
					actions[actionConfig.get('action').toLowerCase()] = {
						"customer": actionConfig.get('customer'),
						"serviceProvider": actionConfig.get('serviceProvider'),
						"public": actionConfig.get('public')
					};
				});
			}

			return actions;
		},
		determineDocumentType: function(model) {
			if (!ViewManager.versionRange('8.8.0.0')) {
				return null;
			}

			return this.documentTypeCollection.find(function(doctype) {
				return doctype.get('name') == model.get('name');
			});
		},
		template: ModalTemplate,
		onRender: function() {
			this.$el.rhythmCivicsTooltipInit();
			this.$el.rhythmThemeInitCivics();
			this.$el.find('.droppy').rhyCivicsDroppy();

			this.$el.rhythmThemeInit();

			this.ui.description.maxlength();
			this.ui.$imagePreview.hide();
			this.ui.$nonImagePreview.hide();

			var self = this;
			var theAttributes = this.buildAttributeTable();

			if (theAttributes && theAttributes.length > 0) {
				this.attributesTableView = new AttributesTable({
					config: self.config,
					collection: theAttributes,
					numDisplayedAttributes: theAttributes.length,
					canUpdate: self.canUpdate
				})

				this.attribRegion.show(this.attributesTableView);
			} else {
				this.ui.attributeTable.hide();
			}

			if (this.isAddProcess) {
				this.previewAttachmentIconThumbnail();
			} else {
				this.ui.$imagePreview.show();
			}

		},
		previewAttachmentIconThumbnail: function() {
			var self = this;
			const imgThumbnailHeight = 100;

			var mimeType = self.model.get('File').get('Type');
			if (mimeType != undefined && typeof self.ui.$imagePreview === 'object' || typeof this.ui.$iconPreview === 'object') {
				if (mimeType != null && mimeType.split('/')[0] === 'image') {
					var attachmentReader = new FileReader();
					attachmentReader.onload = function(e) {
						if (typeof self.ui.$imagePreview === 'object') {
							var image = new Image();
							image.src = e.target.result;
							image.onload = function() {
								if (typeof this.height !== 'undefined' && this.height < imgThumbnailHeight && this.height > 0) {
									self.ui.$imagePreview.height(this.height);
								} else {
									self.ui.$imagePreview.height(imgThumbnailHeight);
								}
								self.ui.$imagePreview.attr('src', image.src);
							}
						}
					}

					if (self.file && self.file instanceof Blob) {
						attachmentReader.readAsDataURL(self.file);
						self.ui.$imagePreview.show();
					}

				} else {
					self.ui.$nonImagePreview.show();
				}
			}
		},
		closeClicked: function() {
			this.destroy();
		},
		previousClicked: function() {
			this.doSubmit(true, false);
		},
		nextClicked: function() {
			this.doSubmit(true, true);
		},
		getDocumentType: function() {
			var self = this;
			this.documentType = this.documentTypeCollection.find(function(doctype) {
				return doctype.get('name') == self.model.get('documentType').get('name');
			});
		},
		onDocumentTypeChanged: function() {
			var self = this;

			// can only do this if the instrument is not yet submitted
			if (self.isAddProcess) {
				var droppyValue = Utils.civicsDropdownValue(this.ui.$documentType);

				if (droppyValue.length > 0) {
					var selectedDocumentType = this.documentTypeCollection.find(function(doctype) {
						return doctype.get('name') == droppyValue;
					});

					if (typeof selectedDocumentType == 'undefined') {
						ViewManager.errorToWindow({
							"error": {
								"validationError": {
									"documentType": i18n.t('CIVICS.ATTACHMENTS.DOCUMENT_TYPE_REQUIRED')
								}
							}
						}, self);
						return;
					}

					this.documentType = selectedDocumentType;

					var attrTable = this.buildNewAttributeTable(selectedDocumentType.get('attributes'));


					self.attributesTableView = new AttributesTable({
						config: self.config,
						collection: attrTable,
						numDisplayedAttributes: attrTable.length,
						canUpdate: true
					});

					this.attribRegion.show(self.attributesTableView);

					if (attrTable.length == 0) {
						self.ui.attributeTable.hide();
					} else {
						self.ui.attributeTable.show();
					}

				} else {
					self.ui.attributeTable.hide();
				}
			}
		},
		submitClicked: function() {
			this.doSubmit(false, false);
		},
		doSubmit: function(loadNewAttachment, loadNext) {
			var self = this;
			var attributeData = ViewManager.fromWindow(this.ui.attributeTable);
			var documentData = ViewManager.fromWindow(this.ui.dataForm);

			var hasError = false;
			var validationError = {};
			var mainDataValidationError = {};
			var missingRequirements = [];

			if (documentData["title"] == null || _.isEmpty(documentData["title"].trim())) {
				// just set to blank - it can be blank, but the title property needs to be in the request.
				documentData["title"] = " ";
			}

			var requiredAttributes = {};
			var requiredDocTypes = {};
			var numbers = ["integer", "short", "long", "float8", "currency", "decimal"];

			var docTypeAttributes = this.documentTypeCollection.find(function(doctype) {
				if(self.documentType.get('name') == doctype.get('name'))
				{
					return doctype.get('attributes');
				}
			});

			docTypeAttributes.get('attributes').each(function(a) {
				requiredAttributes[a.get('name')] = a.get('isRequired');
				requiredDocTypes[a.get('name')] = a.get('type');
			});

			var attributes = [];

			if (!_.isEmpty(attributeData)) {
				for (attribute in attributeData) {
					if (requiredAttributes[attribute] == true && (_.isEmpty(attributeData[attribute]) || attributeData[attribute] == constants.DATE_TIME_MIN_VAL
						|| (numbers.indexOf(requiredDocTypes[attribute].toLowerCase()) != -1 && attributeData[attribute].toString() == '0' ))) {
						if (!this.isAddProcess) {
							hasError = true;
							validationError[attribute] = i18n.t('CIVICS.ATTACHMENTS.ATTRIBUTE_REQUIRED');
						} else {
							missingRequirements.push(attribute);
						}
					} else {
						attributes.push({
							"name": attribute,
							"value": (attributeData[attribute] != undefined) ? attributeData[attribute] : ""
						});
					}
				}
			}

			documentData["missingRequirements"] = missingRequirements;


			if (this.isAddProcess) {
				var newDocumentType = this.documentTypeCollection.find(function(doctype) {
					return doctype.get('name') == documentData.documentType;
				});
			}

			ViewManager.resetErrorMessages(this);

			//if addProcess reset the hasError
			hasError = (self.isAddProcess) ? false : hasError;

			if (self.isAddProcess && typeof newDocumentType == 'undefined') {
				ViewManager.errorToWindow({
					validationError: {
						"documentType": i18n.t('CIVICS.ATTACHMENTS.DOCUMENT_TYPE_REQUIRED')
					}
				}, this);
				return;

			}

			if (!self.canUpdate) {
				hasError = false;
			}

			if (hasError) {
				ViewManager.errorToWindow({
					validationError: mainDataValidationError
				}, this);
				this.displayAttributeErrors(validationError);
			} else {
				ViewManager.loading(true);

				var myModel = new AttachmentModel(documentData);

				var data = {
					'parentMoniker': this.parentMoniker,
					'parentPrimaryKey': this.parentPrimaryKey,
					'provider': this.model.get('provider'),
					'documentType': {
						"attributes": attributes
					},
					'id': this.model.get('id'),
					'filename': this.model.get('filename')
				};

				if (self.isAddProcess) {
					data.documentType.name = newDocumentType != null ? newDocumentType.get('name') : "";
				} else {
					data.documentType.name = self.documentType.get('name');
				}

				if( self.config.IsForBilling == true )
					data.accountId = self.config.BillingAccountKey;

				myModel.set(data);

				myModel.isSave = true;

				if (!self.isAddProcess) {
					if (self.canUpdate) {
						myModel.save(null, {
							success: function() {
								ViewManager.loading(false);
								self.model.set('title', myModel.get('title'));
								self.model.set('description', myModel.get('description'));
								self.model.get('documentType').set(data.documentType);

								if (!loadNewAttachment) {
									AddAttachmentChannel.trigger('attachments:edit', myModel);

									self.destroy();
								} else {
									if (loadNext) {
										self.model = self.parentCollection.at(self.parentCollection.indexOf(self.model) + 1);
										self.getDocumentType();
										var acts = self.getActionPermissions(self.documentType);
										self.canUpdate = (self.isCustomer && acts.update.customer) || (self.isServiceProvider && acts.update.serviceProvider) || (self.isPublic && acts.update.public);

										self.render();
									} else {
										self.model = self.parentCollection.at(self.parentCollection.indexOf(self.model) - 1);
										self.getDocumentType();
										var acts = self.getActionPermissions(self.documentType);
										self.canUpdate = (self.isCustomer && acts.update.customer) || (self.isServiceProvider && acts.update.serviceProvider) || (self.isPublic && acts.update.public);

										self.render();
									}
								}


							},
							error: function(model, response, options) {
								ViewManager.loading(false);
								ViewManager.errorToWindow(response, self);
							}
						});
					} else {
						if (loadNewAttachment) {
							if (loadNext) {
								self.model = self.parentCollection.at(self.parentCollection.indexOf(self.model) + 1);
								self.getDocumentType();
								var acts = self.getActionPermissions(self.documentType);
								self.canUpdate = (self.isCustomer && acts.update.customer) || (self.isServiceProvider && acts.update.serviceProvider) || (self.isPublic && acts.update.public);

								self.render();
							} else {
								self.model = self.parentCollection.at(self.parentCollection.indexOf(self.model) - 1);
								self.getDocumentType();
								var acts = self.getActionPermissions(self.documentType);
								self.canUpdate = (self.isCustomer && acts.update.customer) || (self.isServiceProvider && acts.update.serviceProvider) || (self.isPublic && acts.update.public);

								self.render();
							}
						}
						ViewManager.loading(false);
					}
				} else {
					self.model.set('title', myModel.get('title'));
					self.model.set('description', myModel.get('description'));
					self.model.get('documentType').set(data.documentType);
					self.model.set('missingRequirements', myModel.get('missingRequirements'));
					ViewManager.loading(false);


					if (!loadNewAttachment) {
						AddAttachmentChannel.trigger('attachments:edit', myModel);

						self.destroy();
					} else {
						if (loadNext) {
							self.model = self.parentCollection.at(self.parentCollection.indexOf(self.model) + 1);
							self.loadImageThumbnail(self.model.get('fileName'));
							self.getDocumentType();
							self.render();

						} else {
							self.model = self.parentCollection.at(self.parentCollection.indexOf(self.model) - 1);
							self.loadImageThumbnail(self.model.get('fileName'));
							self.getDocumentType();
							self.render();

						}
					}
				}
			}
		},
		loadImageThumbnail: function(fileName) {
			var self = this;

			if (self.newAttachmentsCollection.models) {
				var newAttachment = self.newAttachmentsCollection.where({ fileName: fileName });
				if (newAttachment.length == 1) {
					var file = newAttachment[0].get("file");
				}
			} else {
				var newAttachment = _.findWhere(self.newAttachmentsCollection, { fileName: fileName });
				if (newAttachment) {
					var file = newAttachment.file;
				}
			}
			if (file && file instanceof Blob) {
				self.file = file;
				self.ui.$imagePreview.show();
			}
		},
		displayAttributeErrors: function(validationError) {
			// ViewManager.errorToWindow doesn't work here
			// because the fields are formatted differently
			for (error in validationError) {
				var selector = "[name='{0}']".format(error);
				var formElement = this.ui.attributeTable.find(selector);

				var newError = $('<div class="helper-msg-container"><div class="error-message"></div></div>');
				newError.find(".error-message").append(Utils.outputErrorMessage(ViewManager.htmlSafeString(validationError[error])));

				formElement.closest('div.field').append(newError);
				formElement.parents('.attribute-table').find('.field').addClass('error');
			}
			this.showError(i18n.t('CIVICS.ATTACHMENTS.MISSING_REQUIRED_INFO'));
		},
		showError: function(message) {
			if (this.ui.$failed.text().indexOf(message) < 0) {
				var newError = $('<div class="error-message"></div>');
				newError.append(Utils.outputErrorMessage(message));
				this.ui.$failed.append(newError);
			}
			this.ui.$failed.show();
		},
		buildNewAttributeTable: function(attributesCollection) {
			var self = this;
			var theAttributes = self.getAttributes(attributesCollection);

			theAttributes.comparator = function(model) {
				return model.get('displayOrder');
			};
			theAttributes.sort();

			return theAttributes;
		},
		buildAttributeTable: function() {
			var self = this;

			var attributesFromModel = this.model.get('documentType').get('attributes');

			var theAttributes = self.getAttributes(this.documentType.get('attributes'));

			theAttributes.comparator = function(model) {
				return model.get('displayOrder');
			};
			theAttributes.sort();

			theAttributes.each(function(item) {
				item.set('attributeValue', null);

				var attrib = attributesFromModel.find(function(attr) {
					return attr.get('name') == item.get('name');
				});
				if (attrib != null) {
					item.set('attributeValue', Utils.formatAttributeValue(item.get('type'), attrib.get('value')));
				}
			});

			return theAttributes;

		},
		getAttributes: function(attributesCollection){
			let theAttributes = [];
			let today = new Date();
			if (this.isCustomer || this.isServiceProvider) {
				theAttributes = new Backbone.Collection(attributesCollection.filter(function(at) {
					if(AvailableFeatures.FilterOldAttachmentAttributes())
						return true;
					else
						return at.get('showInPortal') && (at.get('expire').includes(constants.DATE_TIME_MIN_VAL) || new Date(at.get('expire')) > today)
								&& (at.get('effective').includes(constants.DATE_TIME_MIN_VAL) || new Date(at.get('effective')) <= today);;
				}));
			} else {
				theAttributes = new Backbone.Collection(attributesCollection.filter(function(at) {
					if(AvailableFeatures.FilterOldAttachmentAttributes())
						return at.get('isPublic');
					else
						return at.get('showInPortal') && at.get('isPublic') && (at.get('expire').includes(constants.DATE_TIME_MIN_VAL)  || new Date(at.get('expire')) > today)
					 				&& (at.get('effective').includes(constants.DATE_TIME_MIN_VAL) || new Date(at.get('effective')) <= today);
				}));
			}
			return theAttributes;
		},
		templateHelpers: function() {
			var self = this;
			return {
				singleDocumentType: self.documentTypeCollection.length == 1,
				numDisplayedAttributes: this.documentType.get('attributes').filter(function(at) {
					return at.showInPortal;
					// this is a display thing - if it's too close to the bottom of the
					// modal it should open upwards so we need to know
					// how many attributes there are
				}).length,
				attachmentTitle: this.model.get('title'),
				attachmentPosition: this.parentCollection.indexOf(this.model) + 1,
				attachmentCount: this.parentCollection.length,
				previousDisabled: this.parentCollection.indexOf(this.model) == 0,
				nextDisabled: this.parentCollection.indexOf(this.model) == (this.parentCollection.length - 1),
				documentTypes: this.documentTypeCollection.toJSON(),
				disableDocumentTypeChange: !this.isAddProcess,
				isAddProcess: this.isAddProcess,
				disableFields: !this.canUpdate,
				canUpdate: this.canUpdate,
				thumbnailUrl: this.model.get('thumbnailUrl'),
				fileType: this.model.get('filename') != null ? this.model.get('fileName').substring(this.model.get('fileName').lastIndexOf('.')) : ''
			};
		},
	});
});
